/* eslint-disable */
import { useState } from 'react';
import { FaBuilding, FaMapMarkerAlt, FaArrowRight, FaChevronDown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { MdOutlineDeleteSweep } from 'react-icons/md';
import Swal from 'sweetalert2';
import {
  deleteCleaner,
  deleteContractor,
  deleteSpecialAccess,
  deleteUser,
  getAllCleaner,
  getAllContractor,
  getAllSpecialAcess,
  getBnbList,
  getUsers,
  deleteUploads,
  getContractProperties,
} from '../../helper/backend_helper';
import appConfig from '../../config';

const getContractModeLabel = (contract) => {
  const mode = contract?.signedContractMode || contract?.selectedContractMode;
  return mode === 'allInclusive' ? 'All Inclusive' : 'Standard';
};

export default function ContractCard({ data, activeTab }) {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleDelete = async (row) => {
    console.log(row.signatureFile);
    console.log(row.companyInfo.visuraSocietaria);
    console.log(row.companyOwner.documentCopy);
    console.log(row.companyOwner.fiscalCodeCopy);
    console.log(row.privateOwner.documentCopy);
    console.log(row.privateOwner.fiscalCodeCopy);

    const res = await getContractProperties(row?._id);
    const properties = res?.data?.data || [];
    const propertyImages = properties.flatMap((prop) => [
      ...(prop.visuraCatastale || []),
      ...(prop.rentalContract || []),
      ...(prop.cinCisDocument || []),
      ...(prop.policePortal || []),
    ]);
    console.log(propertyImages);
    const allImages = [
      ...row.signatureFile,
      ...row.companyInfo.visuraSocietaria,
      ...row.companyOwner.documentCopy,
      ...row.companyOwner.fiscalCodeCopy,
      ...row.privateOwner.documentCopy,
      ...row.privateOwner.fiscalCodeCopy,
      ...propertyImages,
    ];
    console.log(allImages);
    try {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to delete this Contractor?',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      });

      if (confirmed.isConfirmed) {
        const headers = {
          headers: {
            'Content-Type': 'application/json',
          },
        };

        // await Promise.all(
        //   allImages.map(async (image) => {
        //     const data = {
        //       filename: image,
        //     };
        //     await deleteUploads(data, headers); // Delete each image
        //   })
        // );
        await Promise.all(
          allImages.map(async (image) => {
            const data = {
              filename: image,
            };
            try {
              await deleteUploads(data, headers); // Try deleting the image
            } catch (err) {
              if (err?.response?.status === 404) {
                console.warn(`File not found: ${image}, skipping...`);
                return; // Skip this file
              } else {
                throw err; // Re-throw other errors to be caught in the outer try-catch
              }
            }
          })
        );

        const response = await deleteContractor(row._id, headers);
        Swal.fire({
          icon: 'success',
          title: 'Contractor deleted successfully',
        });
        fetchData();
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'An error occurred while deleting',
      });
    }
  };

  return (
    <div>
      <div className="max-w-3xl  p-4 bg-white rounded-xl shadow border space-y-2">
        {/* Header */}
        <div className="flex items-center justify-between cursor-pointer">
          <div className="flex items-center space-x-2">
            <FaBuilding className="text-purple-600" />
            <h2 className="text-lg font-semibold">
              {activeTab === 'name'
                ? data?.ownerType === 'company'
                  ? `${data?.companyInfo?.companyName} (${data?.name})`
                  : `${data?.privateOwner?.firstName} ${data?.privateOwner?.lastName} (${data?.name})`
                : data?.privateOwner?.city || data?.companyOwner.city}
            </h2>
          </div>
          <div className="flex items-end space-x-2">
            <span
              className={`text-xs px-2 py-1 rounded-full font-semibold ${
                (data?.signedContractMode || data?.selectedContractMode) === 'allInclusive'
                  ? 'bg-emerald-100 text-emerald-700 border border-emerald-200'
                  : 'bg-slate-100 text-slate-700 border border-slate-200'
              }`}
              title="Contract mode signed by owner"
            >
              {getContractModeLabel(data)}
            </span>
            {data?.adminCorrection?.updatedAt && (
              <span className="text-xs px-2 py-1 rounded-full font-semibold bg-amber-100 text-amber-700 border border-amber-200">
                Corrected
              </span>
            )}
            <div
              onClick={() => setIsOpen(!isOpen)}
              className="cursor-pointer flex items-center space-x-2 text-sm text-gray-500"
            >
              <span>
                {data?.properties?.length} {data?.properties?.length === 1 ? 'property' : 'properties'}
              </span>
              <FaChevronDown className={`transform transition-transform ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
            </div>
            {/* <MdOutlineDeleteSweep
              onClick={() => handleDelete(data)}
              className="text-red-600 cursor-pointer"
              size={25}
            /> */}
          </div>
        </div>
        {!isOpen && (
          <div className="text-xs text-gray-500">
            {data?.properties?.map((item, index) => (
              <span key={index}>
                {item?.name}
                {index !== data.properties.length - 1 && ', '}
              </span>
            ))}
          </div>
        )}

        {/* Collapsible Content */}
        {isOpen && (
          <>
            <button
              onClick={() => navigate('/signed/owner_detail', { state: { data } })}
              className="w-full text-left font-semibold border border-gray-300 px-4 py-2 rounded-md"
            >
              View Owner Details
            </button>

            <div>
              <p className="text-sm font-semibold mb-2">Properties:</p>
              {data?.properties.map((property, index) => (
                <div
                  key={index}
                  onClick={() => navigate('/signed/property_detail', { state: { property, data } })}
                  className="flex items-start space-x-4 p-4  rounded-lg border mb-2 hover:bg-gray-100 cursor-pointer"
                >
                  <img
                    src={
                      property?.mainPhoto
                        ? appConfig.FILE_URL + property?.mainPhoto
                        : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsMMUke4L3aBu8jImsZhwYBwzFA3z0HOnRgg&s'
                    }
                    alt="img"
                    className="w-20 h-20 object-cover rounded"
                  />
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold">{property.name}</h3>
                    <div className="text-sm text-gray-600 flex items-center space-x-1">
                      <FaMapMarkerAlt className="text-gray-400" />
                      <span>{property.address}</span>
                    </div>
                    <div className="text-sm text-gray-500 mt-1">
                      {property.size} m<sup>2</sup> • Floor {property.floor} • Max guests: {property.manualMaxGuests}
                    </div>
                  </div>
                  <FaArrowRight className="mt-2 text-gray-600" />
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
